import { GetDataHoraAtual } from 'app/Core/Helpers';
import XAPPService from 'app/Core/services/XAPPService';

export const GET_MENSAGEM = '[MENSAGEM APP] GET MENSAGEM';
export const SAVE_MENSAGEM = '[MENSAGEM APP] SAVE MENSAGEM';

export const MENSAGEM_WARNING = '[MENSAGEM APP] MENSAGEM WARNING';
export const MENSAGEM_INFO = '[MENSAGEM APP] MENSAGEM INFO';
export const MENSAGEM_ERROR = '[MENSAGEM APP] MENSAGEM ERROR';

export function list(_ASetup, _AParams) {

    return (dispatch) => {

        var AActions = [];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "Mensagem", AActions, _ASetup.function, [_ASetup.campo], "SELECIONAR", _ASetup.condicao, [])

        XAPPService.XappSelAction(AActions, _AParams)
            .then((response) => {
                let AParticipantes = {};
                let AMensagens = [];
                if (response.data && response.data.length > 0 && JSON.parse(response.data)[0].data.length > 0) {
                    AParticipantes = JSON.parse(response.data)[0].data[0][_ASetup.campo].participantes;
                    AMensagens = JSON.parse(response.data)[0].data[0][_ASetup.campo].mensagens;
                }
                Promise.all([
                    dispatch({
                        type: GET_MENSAGEM,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        mensagens: AMensagens,
                        participantes: AParticipantes
                    })
                ])//.then(() => dispatch(updateView(_AIDPessoa, _AIDParent)))
            })
            .catch(error => {
                return dispatch({
                    type: MENSAGEM_ERROR,
                    payload: error
                });
            });
    };
}

export function save(_ASetup, _AParams) {
    return (dispatch) => {
        var AActions = [];

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, _ASetup.target, "ATUALIZAR", _ASetup.conteudo, "", _ASetup.condicao, [], 1, [_ASetup.campo]);

        XAPPService.XappDoAction(AActions, _AParams)
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: MENSAGEM_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => dispatch(list(_ASetup, _AParams)))
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: MENSAGEM_INFO,
                            payload: response.info
                        })
                    ]).then(() => dispatch(list(_ASetup, _AParams)))
                }
            }).catch(error => {
                return dispatch({
                    type: MENSAGEM_ERROR,
                    payload: error
                });
            });
    };
}

export function clearReducer() {
    return {
        type: GET_MENSAGEM,
        payload: null
    }
}

export function addParticipante(_ASetup, _AParams) {
    return (dispatch, getState) => {
        _ASetup.conteudo = {
            [_ASetup.campo]: {
                mensagens: getState().Mensagem.mensagens,
                participantes: {
                    ...getState().Mensagem.participantes,
                    [getState().auth.user.data.usuario]: GetDataHoraAtual("usa")
                }
            }
        };
        dispatch(save(_ASetup, _AParams));
    }
}